<template>
<div class="chapter">
<div class="inner_page">
<p class="ifirstcenter">Dedicated to</p>
<p class="firstcenter"><span class="bi">Herb Nootbaar</span></p>
<p class="ifirstcenter">a champion of justice</p>
<p class="ifirstcenter">&amp;</p>
<p class="firstcenter"><span class="bi">Elinor Nootbaar</span></p>
<p class="ifirstcenter">a lover of Scripture</p>
<p> </p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?eb7e5948